(function index(global) {
  'use strict';

  if (!global.NewHomeSource.Tracking.CommentsQuestionsFormTracking ||
      !global.NewHomeSource.GalleryOnPage.CommunityTracking.Index) {
    return;
  }

  const rootElement = document.querySelector('[data-component="gallery-on-page"]');
  if (!rootElement) {
    return;
  }

  const commentsQuestionsFormTracking = new global.NewHomeSource.Tracking.CommentsQuestionsFormTracking();
  commentsQuestionsFormTracking
    .setRootNode(document.querySelector('[data-comments-questions-form]'))
    .initialize();

  const communityTracking = new global.NewHomeSource.GalleryOnPage.CommunityTracking.Index();
  communityTracking
    .setGalleryElement(rootElement)
    .create();
}(window));
